const SET_MARKERS = {
  main(map, center, popup = false, className) {
    this.divElement = document.createElement('div');
    this.divElement.className = className || 'hosman-marker';

    const marker = new mapboxgl.Marker(this.divElement)
    .setLngLat(center)
    .addTo(map);

    if(popup !== false) marker.setPopup(popup)
    return marker
  },

  specific(map, item) {
    const divEl = document.createElement('div');
    divEl.classList.add('w-4', 'h-4', 'rounded-full', 'border-2', 'border-white');
    if (item.state === 'sold') {
      divEl.classList.add('bg-ih-green');
    } else {
      divEl.classList.add('bg-ih-blue');
    }

    new mapboxgl.Marker(divEl)
      .setLngLat({ lat: item.lat, lng: item.lng })
      .addTo(map);
  }
}

export default SET_MARKERS;
